import {Injectable} from '@angular/core';

import {HttpClient} from '@angular/common/http';

import {Observable} from 'rxjs';
import {Customer} from '../models/customer';
import {CustomerAccount} from '../models/customer-account';
import {CreditDebitCard} from '../models/debit-card';
import {TransactionsResponse} from '../models/transactions-response';
import {BaseService} from '../../../services/base.service';
import {AuthService} from "./auth.service";
import {CustomerFull} from '../models/customer-full';
import {User} from '../models/user';
import {ChequeRequest} from '../models/cheque-request';

@Injectable({
    providedIn: 'root'
})
export class CustomerService extends BaseService {


    httpOptions;

    constructor(private authService: AuthService, private httpClient: HttpClient) {
        super();

        this.httpOptions = authService.getHttpOptions();
    }

}
